module.exports = __webpack_public_path__ + "52302f54cd671757ec1c364a2f983ff4.png";